import axios from '@/plugins/axios.js';

/**
 * Backend resolver endpoints. Each function returns a Promise<string>
 * carrying a freshly signed URL whose TTL starts at request time.
 */
export const SignedUrlResolvers = {
    audioNote(commentId: number | string): Promise<string> {
        return get(`v1/comments/${commentId}/audio-url`);
    },

    commentAttachment(commentId: number | string): Promise<string> {
        return get(`v1/comments/${commentId}/attachment-url`);
    },

    communicationAttachment(communicationId: number | string, index: number): Promise<string> {
        return get(`v1/communications/${communicationId}/attachment-url`, { index });
    },

    communicationRecording(communicationId: number | string): Promise<string> {
        return get(`v1/communications/${communicationId}/recording-url`);
    },

    twilioRecording(recordingSid: string, communicationId: number | string): Promise<string> {
        return get(`v1/recordings/${recordingSid}/url`, { communicationId });
    },
};

export type SignedUrlKind = keyof typeof SignedUrlResolvers;

async function get(path: string, params?: Record<string, unknown>): Promise<string> {
    const response = await axios.get(path, params ? { params } : undefined);
    const url = response?.data?.url;
    if (typeof url !== 'string' || !url) {
        throw new Error(`signedUrl resolver: ${path} returned no url`);
    }
    return url;
}

/**
 * Stable cache key for a (kind, params) pair.
 */
export function cacheKey(kind: SignedUrlKind, params: ReadonlyArray<unknown>): string {
    return `${kind}:${params.map((p) => String(p ?? '')).join(':')}`;
}
